import { UPDATE_ALLOWANCE } from "./constants.allowance.store";
export default {
  [UPDATE_ALLOWANCE](state, payload) {
    let tmp = state.data;
    tmp[payload.key] = payload.allowance;
    state.data = { ...tmp };
  },
};
